import React, { useState, useEffect } from "react"

import ExpandButton from "./ExpandButton"

const Component = ({ onClick, expanded }) => {
  const [enabled, setEnabled] = useState(false)
  useEffect(() => setEnabled(true), [])

  return (
    <ExpandButton enabled={enabled} onClick={onClick} expanded={expanded} />
  )
}

export default Component
